// -----------------------------------------------------------------------
// <copyright file="AuthToken.ts" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

export enum TokenType {
  RPS = 'RPS',
  AAD = 'AAD',
}

export enum EmeraldSigninType {
  SilentPreferred = 0,
  SilentOnly = 1,
  ForceSignin = 2,
}

export type RPSAuthTokenCommand = {
  TokenType: string;
  SiteName: string;
  SitePolicy: string;
  SigninType: EmeraldSigninType;
  Purpose: string;
};

export type AadAuthTokenCommand = {
  TokenType: string;
  Resource: string;
  Scope: string;
  SigninType: EmeraldSigninType;
  Purpose: string;
};

export type AuthTokenRequest = {
  command: string;
  context: RPSAuthTokenCommand | AadAuthTokenCommand;
};

export enum WebTokenRequestStatus {
  Success = 0,
  UserCancel = 1,
  AccountSwitch = 2,
  UserInteractionRequired = 3,
  AccountProviderNotAvailable = 4,
  ProviderError = 5,
}

export type AuthTokenResult = {
  Token: string;
  ExpirationTime: string;
  Purpose: string;
  ResponseStatus: WebTokenRequestStatus;
  ResponseErrorCode: number;
  ResponseErrorMessage: string;
  FirstName: string;
  LastName: string;
  UserName: string;
};
